import axios from "axios";
import store from "@/store";

const axiosAccountApi = axios.create({
    baseURL: process.env.VUE_APP_ACCOUNT_API_URL
});


axiosAccountApi.interceptors.request.use(
    config => {
        const token = store.state.User.token || Cookies.get("token");
        if (token) {
            config.headers = {
                ...config.headers,
                "Visitor-Token": token
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

axiosAccountApi.interceptors.response.use(response => {
    // Do something with response data
    return response;
}, error => {
    // Only report errors on production
    if (process.env.NODE_ENV !== "development") {
        Sentry.captureException(error);
    }
    // Do something with response error
    return Promise.reject(error);
});

window.axiosAccountApi = axiosAccountApi;
export default axiosAccountApi;
